<chart-details-layout 
    [chartDetails]="chartDetails" 
    [isLoading]="isLoading"
    [showFormButtons]="showFormButtons"
    (save)="onSaveSettings()"
    (cancel)="onRevertSettings()">
    <manuals-language-chart chart [showTitle]="false"></manuals-language-chart>
    <base-details detailsComponent
        *ngIf="!isLoading"
        [chartDetails]="chartDetails"
        [generalSettings]="config?.generalSettings"
        (generalSettingsChange)="onGeneralSettingsChange($event)"
    >
    </base-details>
</chart-details-layout>
